
export const UPDATE_USER_REVIEWS =
  'reviews/UPDATE_USER_REVIEWS';
export const UPDATE_CAR_TOP_REVIEWS =
  'reviews/UPDATE_CAR_TOP_REVIEWS';
export const UPDATE_DEALER_TOP_REVIEWS =
  'reviews/UPDATE_DEALER_TOP_REVIEWS';
export const UPDATE_CAR_RECENTLY_VIEWED =
  'reviews/UPDATE_CAR_RECENTLY_VIEWED';
export const UPDATE_DEALER_RECENTLY_VIEWED =
  'reviews/UPDATE_DEALER_RECENTLY_VIEWED';
export const UPDATE_MOST_REVIEWED_CAR =
  'reviews/UPDATE_MOST_REVIEWED_CAR';
export const UPDATE_MOST_REVIEWED_DEALER=
  'reviews/UPDATE_MOST_REVIEWED_DEALER';